import { Layout } from 'antd'
import { useAuth } from 'AuthContext';
import React from 'react'

export default function Footer() {
    const { user } = useAuth();
    return <div>
        <Layout.Footer style={{ padding: 0 }}>
            {/* <div style={{
                backgroundSize: "cover",
                backgroundColor: "rgb(0 16 28)",
                backgroundImage: `url(${`${process.env.PUBLIC_URL}/img/bgfooter.png`})`,
                padding: 10
            }}>
            </div> */}
            <div style={{ textAlign: 'center', }}>
                Copyright {new Date().getFullYear()} © hoctot.ai
            </div>
        </Layout.Footer>
    </div>
}
